import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';

import App from './app';
import './index.css';
import './polyfills';
import { enableMocking } from './shared/tests/utils/enableMocking';

if (import.meta.env.VITE_ENABLE_MOCKING) {
  await enableMocking();
}

const root = createRoot(document.querySelector('#root') as HTMLElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
